import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FiMenu, FiX } from "react-icons/fi";

const Navibar = () => {
  const [activeLink, setActiveLink] = useState(null);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleScrollToSection = (e, sectionId) => {
    e.preventDefault();
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 84; // navbar height (84px)
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
      setActiveLink(sectionId);
    }
  };

  return (
    <nav className="sticky top-0 w-full bg-white z-50 shadow-sm">
      <div className="w-full max-w-[1300px] min-h-[84px] md:px-8 px-4 mx-auto flex justify-between items-center relative">
      <a 
        href="https://helix.org"
        className="cursor-pointer"
      >
        <img
          src="/assets/logo.svg"
          alt="Helix Logo"
          className="w-[97px] h-[24px] hover:opacity-80 transition-opacity duration-200"
        />
      </a>

      <div className="hidden md:flex items-center gap-5">
        {linksData.map((item, index) => {
          if (item.isExternal) {
            return (
              <a
                key={index}
                href={item.path}
                target="_blank"
                rel="noopener noreferrer"
                className="text-[14px] font-normal border-[1px] px-3 py-2 rounded-[12px] text-gray-1 transition-all duration-200 ease-in-out border-transparent bg-transparent hover:bg-gray-50 hover:scale-[1.02]"
              >
                {item.name}
              </a>
            );
          }
          if (item.isInternalRoute) {
            return (
              <Link
                key={index}
                to={item.path}
                className="text-[14px] font-normal border-[1px] px-3 py-2 rounded-[12px] text-gray-1 transition-all duration-200 ease-in-out border-transparent bg-transparent hover:bg-gray-50 hover:scale-[1.02]"
              >
                {item.name}
              </Link>
            );
          }
          return (
            <a
              key={index}
              href={`#${item.path}`}
              onClick={(e) => handleScrollToSection(e, item.path)}
              className={`text-[14px] font-normal border-[1px] px-3 py-2 rounded-[12px] text-gray-1 transition-all duration-200 ease-in-out ${
                activeLink === item.path
                  ? "border-[#F0F0F5] bg-[#FBFAFA] scale-105"
                  : "border-transparent bg-transparent hover:bg-gray-50 hover:scale-[1.02]"
              }`}
            >
              {item.name}
            </a>
          );
        })}
      </div>

      <div className="hidden md:flex gap-3 items-center">
        <a
          href="https://ai.helix.org"
          target="_blank"
          rel="noopener noreferrer"
          className="text-[14px] font-semibold text-white h-[36px] rounded-[12px] bg-blue-1 px-6
                       transition-all duration-200 ease-in-out
                      shadow-md hover:shadow-lg active:shadow-sm
                      transform hover:scale-105 active:scale-95 flex items-center justify-center"
        >
          Launch App
        </a>
      </div>

      {/* Mobile Hamburger Button */}
      <button
        className="md:hidden text-gray-700 focus:outline-none z-50 relative"
        onClick={toggleMenu}
      >
        <div className="relative w-6 h-6">
          <FiMenu 
            className={`absolute inset-0 w-6 h-6 transition-all duration-300 ease-in-out ${
              isMenuOpen 
                ? 'opacity-0 rotate-90 scale-75' 
                : 'opacity-100 rotate-0 scale-100'
            }`} 
          />
          <FiX 
            className={`absolute inset-0 w-6 h-6 transition-all duration-300 ease-in-out ${
              isMenuOpen 
                ? 'opacity-100 rotate-0 scale-100' 
                : 'opacity-0 -rotate-90 scale-75'
            }`} 
          />
        </div>
      </button>

      {/* Mobile Menu with Smooth Animation */}
      <div
        className={`md:hidden absolute top-full pb-4 z-50 left-0 right-0 bg-white shadow-xl rounded-b-lg  
                   transition-all duration-300 ease-out ${
          isMenuOpen 
            ? "opacity-100 visible translate-y-0" 
            : "opacity-0 invisible -translate-y-4"
        }`}
        style={{
          clipPath: isMenuOpen 
            ? 'inset(0 0 0 0)' 
            : 'inset(0 0 100% 0)',
          transition: 'opacity 0.3s ease-out, transform 0.3s ease-out, clip-path 0.3s ease-out, visibility 0.3s ease-out'
        }}
      >
        <div className="p-4">
          <div className="flex flex-col gap-3">
            {linksData.map((item, index) => {
              if (item.isExternal) {
                return (
                  <a
                    key={index}
                    href={item.path}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={() => setIsMenuOpen(false)}
                    className={`text-[14px] font-normal border-[1px] px-3 py-2 rounded-[12px] text-gray-1 
                               transition-all duration-200 ease-in-out transform hover:scale-[1.02] 
                               ${isMenuOpen ? 'translate-y-0 opacity-100' : 'translate-y-2 opacity-0'}
                               border-transparent bg-transparent hover:bg-gray-50`}
                    style={{
                      transitionDelay: isMenuOpen ? `${index * 50}ms` : '0ms'
                    }}
                  >
                    {item.name}
                  </a>
                );
              }
              if (item.isInternalRoute) {
                return (
                  <Link
                    key={index}
                    to={item.path}
                    onClick={() => setIsMenuOpen(false)}
                    className={`text-[14px] font-normal border-[1px] px-3 py-2 rounded-[12px] text-gray-1 
                               transition-all duration-200 ease-in-out transform hover:scale-[1.02] 
                               ${isMenuOpen ? 'translate-y-0 opacity-100' : 'translate-y-2 opacity-0'}
                               border-transparent bg-transparent hover:bg-gray-50`}
                    style={{
                      transitionDelay: isMenuOpen ? `${index * 50}ms` : '0ms'
                    }}
                  >
                    {item.name}
                  </Link>
                );
              }
              return (
                <a
                  key={index}
                  href={`#${item.path}`}
                  onClick={(e) => {
                    handleScrollToSection(e, item.path);
                    setIsMenuOpen(false);
                  }}
                  className={`text-[14px] font-normal border-[1px] px-3 py-2 rounded-[12px] text-gray-1 
                             transition-all duration-200 ease-in-out transform hover:scale-[1.02] 
                             ${isMenuOpen ? 'translate-y-0 opacity-100' : 'translate-y-2 opacity-0'}
                             ${
                    activeLink === item.path
                      ? "border-[#F0F0F5] bg-[#FBFAFA]"
                      : "border-transparent bg-transparent hover:bg-gray-50"
                  }`}
                  style={{
                    transitionDelay: isMenuOpen ? `${index * 50}ms` : '0ms'
                  }}
                >
                  {item.name}
                </a>
              );
            })}
            <div 
              className={`flex flex-col gap-3 mt-2 transition-all duration-300 ease-out
                         ${isMenuOpen ? 'translate-y-0 opacity-100' : 'translate-y-2 opacity-0'}`}
              style={{
                transitionDelay: isMenuOpen ? `${linksData.length * 50}ms` : '0ms'
              }}
            >
              <a
                href="https://ai.helix.org"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[14px] font-semibold text-white h-[36px] rounded-[12px] bg-blue-1 px-6
                           transition-all duration-200 ease-in-out
                          shadow-md hover:shadow-lg active:shadow-sm
                          transform hover:scale-105 active:scale-95 flex items-center justify-center"
              >
                Launch App
              </a>
            </div>
          </div>
        </div>
      </div>
      </div>
    </nav>
  );
};

export default Navibar;

const linksData = [
  {
    path: "about",
    name: "Features",
  },
  {
    path: "hlx",
    name: "HLX",
  },
  {
    path: "governance",
    name: "Community",
  },
  {
    path: "faq",
    name: "FAQ",
  },
  {
    path: "/docs",
    name: "Docs",
    isInternalRoute: true,
  },
];